// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800&family=Nunito:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,200;1,300;1,400;1,500;1,600;1,700;1,800&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: 'Poppins', sans-serif;
  padding: 0;
  box-sizing: border-box;
background-color: #FAFFF6;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
/* custom css */
.slider img {
  max-width: 100%;
  margin: auto;
  outline: none;
}

.app .slick-dots {
  bottom: 30px !important;
  text-align: right !important;
  right: 30px;
}

.app .slick-dots li button:before
{
    width: 15px !important;
    height: 15px !important;
    background-color: #fff;
    border-radius: 50%;
    content: '' !important;
}
.app .slick-dots li.slick-active button:before
{
  width: 25px !important;
  border-radius: 30px;
  opacity: 1 !important;
}
.app .slick-active
{
  margin-right: 10px !important;
}

.logintext .form-group{
  position:relative;
  width: 100%;
}
.pr {
  padding: 0;
  margin: 0;
}

.pl {
  margin: 0;
  padding: 0;
}
.loginpage {
  position: absolute;
  width: 100%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  max-width: 450px;
}

.logo {
  max-width: 133px;
}

.logo img {
  width: 100%;
}

.logintext h2 {
  font-size: 24px;
  font-weight: 500;
  line-height: 36px;
  margin: 0;
  padding-top: 15px;
}

.logintext > p {
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: #000000;
  margin: 0;
  padding: 15px 0px 40px 0px;
}
.error-message {
  position: absolute;
  top: 66px;
  left: 10px;
  font-size: 14px;
  color: red;
}
.logintext h6 a {color: #0F6739;text-decoration: none;font-size: 14px;font-weight: 500;line-height: 18px;}

.logintext h6 {
    margin: 0;
    text-align: right;
}
.logintext button {
  width: 100%;
  height: 48px;
  background: #0F6739;
  border: none;
  border-radius: 8px;
  margin-top: 20px;
  outline: none;
  padding: 0;
  color: #fff;
}
.logintext button a {
  color: #fff;
  display: block;
  height: 48px;
  line-height: 48px;
  width: 100%;
  text-transform: capitalize;
  font-size: 14px;
  text-decoration: none;
}
.logintext button:hover
{
  background: #0F6739; 
  box-shadow: none;
}

.customfield .MuiFormControl-root {
  width: 100%;
  margin-bottom: 20px;
}
.customfield .MuiInputBase-root {
  background: #fafff6;
  border: 1px solid #EEEEEE;
  border-radius: 8px;
}
.customfield .MuiInputBase-root:hover {
  background: #fafff6;
}
.customfield .MuiInputBase-root:focus
{
  background: #fafff6 !important;
}
.customfield .MuiInputBase-root::before
{
  border-bottom: 0;
}
.customfield .MuiInputBase-root::after
{
  border-bottom: 0;
}
.MuiFormLabel-root.Mui-focused
{
color: #0F6739 !important;
}
.customfield .MuiInputBase-root:hover::before
{
  border-bottom: 0 !important;
}

.customfield .MuiButtonBase-root {
  background: transparent !important;
  height: inherit !important;
  margin-top: 0 !important;
width: 100%;
}
.customfield .MuiButtonBase-root img {
  filter: invert(15%) sepia(97%) saturate(3007%) hue-rotate(149deg) brightness(88%) contrast(88%);
}

.customfield .MuiSvgIcon-root {
  color: #0F6739;
  top: -5px;
}

.customfield {
  display: flex;
  position: relative;
}

.pageimage {
  height: 40px;
  width: 40px;
  position: absolute;
  border: 1px solid #EEEEEE;
  top: 9px;
  left: 9px;
  z-index: 9;
  border-radius: 8px;
  line-height: 40px;
  text-align: center;
}
span.pageimage.pageimagelogin {
  top: 16px;
  left: 17px;
}
.forgotpass span.pageimage.pageimagelogin {
  top: 10px;
  left: 10px;
}
.pageimage img {
  filter: invert(28%) sepia(50%) saturate(731%) hue-rotate(96deg) brightness(95%) contrast(90%);
  text-align: center;
  position: relative;
  top: -3px;
}

.customfield .MuiInputBase-input {
  padding-left: 48px;
}
.customfield.search .MuiInputBase-input {
  padding-left: 60px;
  padding-right: 30px;
}
.pageimage-close {
  position: absolute;
  right: 10px;
  top: 15px;
}
.pageimage-close:hover{
  cursor: pointer;
}
.customfield.forgotpass .MuiInputBase-input {
  padding-left: 60px;
}
.change-password-page.customfield .MuiInputBase-input{
padding-left: 60px;
}
.customfield #filled-adornment-password {
  padding-left: 60px;
}
.customfield.custom-number .MuiInputBase-input{
padding-left: 60px;
}
.customfield .MuiFormLabel-root {
  padding-left: 64px;
  font-family: 'Poppins', sans-serif !important;
  font-size: 16px;
  color: #333333;
}

.customfield.customfieldlogin .MuiFormLabel-root {
  padding-left: 70px;
}
.customfield.customfieldlogin .MuiFormLabel-root.Mui-focused
{
  padding-left: 70px !important;
}
.customfield.customfieldlogin .MuiInputBase-input {
  padding-left: 65px;
}
.customfield.customfieldlogin button.MuiButtonBase-root {
  position: relative;
  right: 10px;
}

.customfield .MuiInputBase-root.MuiFilledInput-root.MuiFilledInput-underline.MuiInputBase-colorPrimary.MuiInputBase-formControl.MuiInputBase-multiline.Mui-focused
{
  background: #fafff6 !important;
}
.customfield .MuiInputBase-root.MuiFilledInput-root.MuiFilledInput-underline.MuiInputBase-colorPrimary.MuiInputBase-formControl.MuiInputBase-adornedEnd.Mui-focused
{
  background: #fafff6 !important;
}
/* menu css */

.mainwrap {
  width: 100%;
  height: auto;
  display: flex;
}

.leftsection {
  width: 200px;
  min-height: 100vh;
  box-shadow: 0px 4px 8px 0px #DEFFC3;
  background: #FFFFFF;
  padding: 22px;
  position: fixed;
  left: 0;
  right: 0;
  z-index: 10;
  top: 0;
  bottom: 0;
}

.menulogo {
  width: 110px;
  margin: 15px auto;
  padding-bottom: 20px;
}
.topallmenu {
  min-height: calc(100vh - 246px);
}
.topallmenuwrap {
  overflow-y: auto;
}

.topallmenuwrap ul {
  max-height: 200px;
}

.menulogo img {
  width: 100%;
}

.menulogo ul {padding: 0;}

.menu ul {
  padding: 0;
  margin: 0;
}

.menu ul li {list-style-type: none;padding: 5px 0px;}

.menu ul li a img {
  margin: 0px 10px;
}

.menu ul li a {
  display: flex;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  text-decoration: none;
  padding: 12px 10px;
  color: #666666;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #FAFFF6;
}
.menu ul .lasttwomenu li:nth-of-type(1) a {
  color: #AF4755;
  border-radius: 0;
}
.menu ul .lasttwomenu li:nth-of-type(1)
{
  border-bottom: 1px solid #EEEEEE;
}
.menu ul .lasttwomenu li:nth-of-type(2) a img
{
  background-color: #FAFFF6;
  height: 40px;
  width: 40px;
  padding: 8px;
  border: 1px solid #EEEEEE;
  border-radius: 50px;
}
.rightsection {
  padding: 20px;
  width: calc(100% - 200px);
  position: absolute;
  right: 0;
}
.topSection {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
}

.topSectionleft h3 {
  font-size: 24px;
  font-weight: 600;
  line-height: 36px;
  color: #333333;
}

.topSectionleft h3 span {
  display: block;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  color: #666666;
}

.mainbtn a, .mainbtn button {
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  text-align: center;
  color: #fff !important;
  background: #0F6739;
  padding: 14px 20px;
  border-radius: 8px;
  text-decoration: none !important;
  border: none;
}
.mainbtn button:focus
{
  outline: none;
}
.buttonholder button img {
  position: absolute;
  max-width: 24px;
  top: 33px;
}

.buttonholder {
  position: relative;
}
.no-data-found {
  display: flex;
  justify-content: center;
  padding: 40px 0;
}
.mainbtn a:nth-of-type(2), .bulkBTn{
  background: #77BC43 !important;
  margin-left: 20px;
}
.mainbtn a.csvFile {
  display: block;
  padding: 0;
  background: transparent !important;
  color: #0F6739;
  position: relative;
  top: 20px;
  margin: 0;
}
.mainbtn a.bulkBTn {
  margin: 0;
}
.dashboxwrap {
  display: flex;
  justify-content: space-between;
  padding-bottom: 25px;
  flex-wrap: wrap;
  gap: 20px;
}

.dashbox {
  background: #fff;
  box-shadow: 0px 0px 4px 0px #E3F3FF;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  align-items: center;
  width: calc(25% - 15px);
  justify-content: space-between;
}

.dashbox:last-of-type {
  margin-right: 0px;
}
.dashbox-left h3 {
  font-size: 24px;
  font-weight: 600;
  line-height: 36px;
}

.dashbox-left h4 {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: #666666;
  padding-bottom: 5px;
}

.dashbox-left p {
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: #0F6739;
  margin: 0;
}
.dashbox-left h4.assigned
{
  color: #0F6739;
}
.dashbox-left h4.unassigned
{
  color: #AF4755;
}
.MuiChartsAxis-right {
  display: none;
}
.MuiChartsAxis-left {
  display: none;
}
path.MuiLineElement-root {
  display: none;
}
rect.MuiBarElement-root {
  /* width: 10px; */
  fill: #77BC43;
}

rect.MuiBarElement-root.MuiBarElement-series-auto-generated-id-1 {
  fill: #EEEEEE;
  border-radius: 10px;
}
text.MuiChartsAxis-label {
  display: none;
}

line.MuiChartsAxis-tick {
  display: none;
}

line.MuiChartsAxis-line {
  display: none;
}
text.MuiChartsAxis-tickLabel {
  /* text-anchor: end !important; */
  font-family: 'Poppins';
}
.devicechartwrap {
  display: flex;
  justify-content: space-between;
}
.devicechart {
  box-shadow: 0px 0px 4px 0px #E3F3FF;
  background: #FFFFFF;
  border-radius: 8px;
  padding: 20px;
  width: calc(50% - 10px);
}
.devicechart:first-of-type {
  margin-right: 20px;
}

.devicechart h2 {
  font-size: 24px;
  font-weight: 600;
  line-height: 36px;
}

.devicechart p {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: #333333;
}
.devicechart:nth-of-type(3) {
  margin-top: 20px;
}
.tfirst {
  display: flex;
  align-items: center;
  position: relative;
}

.tfleft {
  max-width: 30px;
}
.tfleft .pageimage {
  border-radius: 50%;
  top: 0;
}

.tfleft2 {
  margin-right: 50px;
}

.tfright2 {
  padding-left: 10px;
}
.tfright p {
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  margin: 0;
}
.chartcustom svg {
  margin-top: 0px;
}
table.MuiTable-root {
  border-top: 1px solid #EEEEEE;
  margin-top: 20px;
}


th.MuiTableCell-root.MuiTableCell-head.MuiTableCell-sizeMedium{
  font-family: inherit;
      white-space: nowrap;
}

td.MuiTableCell-root.MuiTableCell-body.MuiTableCell-sizeMedium{
  font-family: inherit;
}
tr.MuiTableRow-root:nth-child( even )
{
  background-color: #FAFFF6;
}
.MuiPaper-root.MuiPaper-elevation {
  box-shadow: none;
}
.devicechart.tabalwrap {
  padding: 0;
  width: 100%;
}

.tablewrappadd {
  padding: 20px;
  padding-bottom: 0;
}
.tablewrappadd.filter-energy-d {
  display: flex;
  justify-content: space-between;
}
.devicechart.tabalwrap p {
  margin-bottom: 0;
}
.devicechart.tabalwrap b {
  margin-left: 15px;
  cursor: pointer;
}
.tfright span {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: #666666;
  font-family: 'Poppins';
  white-space: nowrap;
}
.tfright p.green
{
  color: #0F6739;
  font-family: 'Poppins';
  text-transform: capitalize;
  white-space: nowrap;
}
.tfright p.green a {
  color: #0F6739;
  font-weight: 500;
  text-decoration: none;
  font-family: 'Poppins';
  text-transform: capitalize;
}
.tfright p.status
{
  color: #77BC43;
}
.adduserwrap {
  display: flex;
}
.userFilter .adduserwrap {
  display: flex;
  flex-wrap: wrap;
}
.userFilter .selectfield{
  max-width: 364px;
}
.css-6hp17o-MuiList-root-MuiMenu-list{
  width: 362px !important;
  overflow-x: auto;
}
.mb-20{
  margin-bottom: 20px;
}
.tfright a:hover {
  text-decoration: none;
}
.adduserwrap .customfield {
  width: 100%;
  margin-right: 20px;
  max-width: 364px;
}
body.popup-open:before {
  background-color: rgb(124 123 123 / 45%);
  position: fixed;
  top: 0;
  left: 0;
  border: 0;
  right: 0;
  width: 100%;
  height: 100%;
  content: "";
  z-index: 100;
}

body.popup-open {
  position: relative;
}
.adduserwrap .customfield:last-of-type {
  margin-right: 0;
}
.proof
{
  font-family: Poppins;
font-size: 16px;
font-weight: 500;
line-height: 24px;
color: #666666;
margin-bottom: 20px;
}
form.MuiBox-root {
  width: 100% !important;
}
.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input {
  padding-right: 32px;
  padding-left: 60px;
}
label#filled-select-currency-label {
  padding-left: 65px;
}
.MuiInputBase-root.MuiFilledInput-root.MuiFilledInput-underline.MuiInputBase-colorPrimary.Mui-focused.MuiInputBase-formControl {
  background: #fafff6;
}
.selectfield {
  width: 100%;
  height: auto;
  position: relative;
  max-width: 400px;
}

img.arrowb {
  right: 15px;
  position: absolute;
  top: 20px;
}
.css-6hp17o-MuiList-root-MuiMenu-list{
  background-color: #fafff6;
}
svg.MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium.MuiSelect-icon {
  display: none;
}

svg.MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium.MuiSelect-icon.MuiSelect-iconFilled.MuiSelect-iconOpen.css-bpeome-MuiSvgIcon-root-MuiSelect-icon {
  display: none;
}
.css-1ff8729-MuiInputBase-root-MuiFilledInput-root.Mui-focused{
  background-color:#fafff6 !important;
}
.EnergySummary1 td.MuiTableCell-root.MuiTableCell-body.MuiTableCell-sizeMedium, .EnergySummary1 .css-1ex1afd-MuiTableCell-root{
  white-space:nowrap;
}
.bothwrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 30px;
}
.devicechart.tabalwrap.inputwrap {
  padding-bottom: 32px;
}

.devicechart.tabalwrap.inputwrap .mainbtn {
  padding-top: 35px;
}
.mainbtn.bulk {
  padding-top: 50px !important;
}.chosefole input {
  height: 56px;
  width: 400px;
}
.chosefole
{
  width: 100%;
  background: #fafff6;
  border: 1px solid #EEEEEE;
  border-radius: 8px;
  height: 56px;
}
.css-zcbmsk-MuiButtonBase-root-MuiButton-root
{
  box-shadow: none !important;
}
#choose {
  justify-content: flex-start;
  padding-left: 55px;
  text-transform: capitalize;
  font-size: 16px;
  color: #333333;
}
.chosefole span {
  font-size: 12px;
  font-weight: 400;
  color: #12121259;
  padding-left: 60px;
  position: absolute;
  top: 26px;
  left: 12px;
  pointer-events: none;
}
.imageuploadmar .chosefole span{
  top: 10px;
}
.userFilter{
  padding: 0 20px;
  padding-top: 25px;

}
.userFilter .selectfield{
margin-right: 20px;
}
.profilewrap {
  width: 100%;
  height: 56px;
  line-height: 56px;
  margin-bottom: 12px;
}

.profilewrap p {
  padding-left: 58px;
  line-height: 56px;
  font-weight: 400;
  font-size: 14px;
}
.bothwrap.tablewrappadd .customfield .MuiFormControl-root {
  margin-bottom: 0px;
}
.customfield.search {
  max-width: 400px;
  width: 100%;
}
.tfleft.tfleftnew {
  margin-right: 15px;
}
/* .mainbtn button.save
{
  padding: 14px 40px;
} */
.topSectionright {
  height: auto;
  z-index: 0;
}
.logintext.Successfully button {
  margin-top: 0;
}
a.menu-item.active {
  background: #0F6739;
  color: #fff;
  border-radius: 8px;
}

a.menu-item.active img {
  filter: invert(100%) sepia(91%) saturate(0%) hue-rotate(308deg) brightness(131%) contrast(101%);
}

.topallmenuwrap::-webkit-scrollbar-track
{
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
	border-radius: 10px;
	background-color: #EEEEEE;
}

.topallmenuwrap::-webkit-scrollbar
{
	width: 3px;
	background-color: #EEEEEE;
}

.topallmenuwrap::-webkit-scrollbar-thumb
{
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
  background-color: #77bc4347;
}
.devicechart.tabalwrap p.redColor {
  color: #AF4755;
}

.devicechart.tabalwrap p.greenColor {
  color: #77BC43;
}
.tfright p button {
  padding: 0;
  background: transparent;
  border: none;
}

.tfright p button {
  margin-left: 15px;
}
.imageuploadmar
{
  margin-bottom: 50px;
}
.mainbtn.bulk button img {
  max-height: 24px;
}
.tfleft.tfleftnew span button {
  border: none;
  background: transparent;
  padding: 0;
}

.tfleft.tfleftnew span button:focus
{
  outline: none;
}

.popup-content {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  padding:20px 0px 15px 20px;
  box-shadow: 0px 0px 4px 0px #E3F3FF;
  border-radius: 10px;
  min-width: 300px;
  z-index: 101;
  max-width: 450px;
}
.popup-inner-body {
  overflow-y: auto;
  max-height: 300px;
  padding-right: 20px;
  min-height: 100px;
}
.poptext p span {
  display: block;
  font-size: 12px;
  font-weight: 400;
  color: #666666;
}
.poptext a,.poptext a:hover
{
  color: #0F6739;
  text-decoration: none;
}
.rs-btn-link:hover{
  text-decoration: none !important;
}
.poptext p {
  font-size: 14px;
  font-weight: 500;
  margin-top: 10px;
}
.poptext p:hover{
  cursor: pointer;
}
.popupCloseBtn {
  margin-top: 10px;
  float: right;
  margin-right: 20px;
  padding: 5px 13px;
  border-radius: 5px;
}
.popupCloseBtn:focus{
  outline: none;
  border: none;
  box-shadow: none;
}
.poptext b {
  color: #0F6739;
  font-size: 14px;
  font-weight: 500;
}
.rs-input-group-addon > svg{
  display: none !important;
}
.rs-input-group-addon{
  background-color: #fafff6 !important;
  position: absolute !important;
  top: 10px !important;
}
.rs-picker-daterange>.rs-input-group.rs-input-group-inside .rs-input{
  padding-right: 15px !important;
  /* width: 350px !important; */
  height: 56px;
  padding-left: 70px;
  background-color: #fafff6;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.87);
}
.rs-picker-daterange>.rs-input-group.rs-input-group-inside .rs-input:focus,.rs-picker-daterange>.rs-input-group.rs-input-group-inside .rs-input:focus-within{
  box-shadow: none !important;
}
.rs-input-group:not(.rs-input-group-disabled):hover,
.rs-input-group:not(.rs-input-group-disabled).rs-input-group-focus,
.rs-input-group:focus-within{
  border-color: #EEEEEE !important;
  box-shadow: none !important;
}
.rs-input-group:not(.rs-input-group-disabled).rs-input-group-focus,
.rs-input-group:focus-within{
  outline: none !important;
}
.rs-input::-webkit-input-placeholder{
  color: rgba(0, 0, 0, 0.87) !important;
}
.popup-content::-webkit-scrollbar-track
{
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
	background-color: #F5F5F5;
  border-radius: 10px;
}

.popup-content::-webkit-scrollbar
{
	width: 6px;
	background-color: #F5F5F5;
}

.popup-content::-webkit-scrollbar-thumb
{
	background-color: #0f673975;
  border-radius: 10px;
}
.tfright button {
  border: none;
  background: transparent;
}

.tfright button:focus
{
  outline: none;
}

.chosefole ::-webkit-file-upload-button {
  color: transparent;
  background-color: transparent;
  outline: 0;
  border: 0;
  padding: 0;
  margin: 0;
}
.rs-calendar-table-cell-is-today .rs-calendar-table-cell-content {
  box-shadow: inset 0 0 0 1px #78bc45 !important;
  box-shadow: inset 0 0 0 1px #78bc45 !important;
}
.rs-picker-popup .rs-calendar .rs-calendar-table-cell:hover .rs-calendar-table-cell-content {
  background-color: #d6fab9 !important;
  background-color: #d6fab9 !important;
  color: #116739 !important;
  color: #116739 !important;
}
.rs-calendar-table-cell-selected .rs-calendar-table-cell-content{
  background-color: #116739 !important;
  color: #fff !important;
}
.rs-calendar-table-cell-in-range::before{
  background-color: #d6fab9 !important;
}
.rs-btn-link{
  color: #116739 !important;
}
.rs-btn-primary{
  background-color: #116739 !important;
}
.rs-btn-link:hover,
.rs-btn-link:focus{
  text-decoration: none !important;
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}
.rs-btn-close:hover svg path,
.rs-btn-close:focus svg path{
  stroke:#116739 !important
}
.rs-anim-fade.rs-anim-in{
  z-index: 10 !important;
}
.rs-picker-toggle-wrapper{
  width: 100% !important;
}
.download-excel span {
  display: block;
  cursor: pointer;
  height: 56px;
}

.download-excel button {
  background-color: #77BC43;
  height: 100%;
  padding: 10px 15px;
  border-radius: 10px;
  color: #fff;
  font-size: 16px;
}
.download-excel button:focus {
  outline: none;
}
.filter-data-eng-summary{
  display: flex;
    gap: 20px;
    flex-wrap: wrap;
}
.open-menu-mobi {
  background-color: #e2ebdd75;
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 1;
  left: 0;
  top: 0;
  display: none;
}
.mob-menu .open-menu-mobi {
  background-color: rgb(226 235 221 / 30%);
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 1;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  display: block;
}
.pop-top-heading h6 {
  color: #666;
  font-size: 16px;
  font-weight: 600;
  padding-bottom: 5px;
}
.greenbtn {
  background-color: #78bc43;
  color: #fff;
}
.red-btn {
  background-color: #dc3545;
  color: #fff;
}
.poptext {
  position: relative;
}

.poptext input {
  display: none;
}
.poptext input:hover{
  cursor: pointer;
}
 .radio-btn-check {
  position: absolute;
  width: 20px;
  height: 20px;
  display: block;
  border: 2px solid #c4c4c4;
  border-radius: 4px;
  top: 16px;
  right: 0;
  pointer-events: none;
}
.poptext label {
  width: 100%;
  margin-bottom: 0;
}
.radio-btn-check:before {
  content: "";
  border: 2px solid #fff;
  width: 8px;
  height: 14px;
  position: absolute;
  transform: rotate(45deg);
  border-top: 0;
  border-left: 0;
  top: -1px;
  left: 4px;
}
.poptext input:checked ~ .radio-btn-check {
  border-color: #78bc43;
  background-color: #78bc43;
}
.css-134s3sw-MuiResponsiveChart-container{
  padding: 30px 0;
  height: auto !important;
}
.user-filter,.user-filter:focus {
  width: calc(100% - 20px);
  padding: 8px 8px;
  border: 1px solid #EEEEEE;
  background: #fafff6;
  border-radius:5px;
  outline: none;
}
.no-device-avl {
  padding: 20px 0;
}
.datepick1 .rs-input-group.rs-input-group-inside .rs-input{
  padding-right: 15px !important;
    height: 56px;
    padding-left: 70px;
    background-color: #fafff6;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.87);
}
.chart-box-bg .MuiChartsLegend-mark{
  fill: #77BC43 !important;
}
.css-1vh1nrb-MuiChartsTooltip-mark{
  background-color: #77BC43 !important;
}
.chart-box-bg .css-1u0lry5-MuiChartsLegend-root{
  display: none !important;
}
.css-134s3sw-MuiResponsiveChart-container{
  margin-left: -50px !important;
  padding-top: 160px;
}
.devicechart .css-134s3sw-MuiResponsiveChart-container .css-13aj3tc-MuiChartsSurface-root{
  height: auto !important;
}
input:-webkit-autofill {
  background-color: #fafff6 !important;
  -webkit-box-shadow: 0 0 0px 1000px #fafff6 inset !important;
}

input:-webkit-autofill {
  background-color: #fafff6 !important;
  box-shadow: 0 0 0px 1000px #fafff6 inset !important;
}
.smin-width-360{
  min-width: 360px;
}
.smin-width-360 .customfield .MuiFormControl-root, .battrey-b-0 .customfield .MuiFormControl-root,.dash-user-f .customfield .MuiFormControl-root{
  margin-bottom: 0px;
}
.css-1k2u9zb-MuiChartsAxis-root .MuiChartsAxis-tickLabel{
  font-size: 11px !important;
}
.adduserwrap.gap-20{
  gap: 20px;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,UAAU;EACV,sBAAsB;AACxB,yBAAyB;AACzB;AACA,gCAAgC;AAChC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;AACA,eAAe;AACf;EACE,eAAe;EACf,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,WAAW;AACb;;AAEA;;IAEI,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;;EAEE,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;EACf,UAAU;AACZ;AACA,iBAAiB,cAAc,CAAC,qBAAqB,CAAC,eAAe,CAAC,gBAAgB,CAAC,iBAAiB,CAAC;;AAEzG;IACI,SAAS;IACT,iBAAiB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV,WAAW;AACb;AACA;EACE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,0BAA0B;EAC1B,eAAe;EACf,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,8BAA8B;AAChC;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;AAClB;AACA;;AAEA,yBAAyB;AACzB;AACA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,wBAAwB;AAC1B,WAAW;AACX;AACA;EACE,+FAA+F;AACjG;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,6FAA6F;EAC7F,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;AACA,kBAAkB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;AACA,kBAAkB;AAClB;AACA;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,8BAA8B;AAChC;AACA;;EAEE,8BAA8B;AAChC;AACA,aAAa;;AAEb;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,OAAO;EACP,QAAQ;EACR,WAAW;EACX,MAAM;EACN,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA,cAAc,UAAU,CAAC;;AAEzB;EACE,UAAU;EACV,SAAS;AACX;;AAEA,aAAa,qBAAqB,CAAC,gBAAgB,CAAC;;AAEpD;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,YAAY;AACd;AACA;;EAEE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,UAAU;EACV,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;EACpB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;AACA;EACE,iCAAiC;EACjC,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;;AAGA;EACE,oBAAoB;MAChB,mBAAmB;AACzB;;AAEA;EACE,oBAAoB;AACtB;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;;EAEE,cAAc;EACd,sBAAsB;EACtB,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;;EAEE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,wCAAwC;EACxC,eAAe;EACf,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,oBAAoB;AACtB,eAAe;AACf,gBAAgB;AAChB,iBAAiB;AACjB,cAAc;AACd,mBAAmB;AACnB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;AACA;EACE,mCAAmC;AACrC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,4BAA4B;AAC9B,CAAC;EACC,YAAY;EACZ,YAAY;AACd;AACA;;EAEE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;AACA;;EAEE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,SAAS;AACX;AACA;EACE,eAAe;EACf,iBAAiB;;AAEnB;AACA;AACA,kBAAkB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;;;GAGG;AACH;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,+FAA+F;AACjG;;AAEA;;CAEC,iDAAiD;CACjD,mBAAmB;CACnB,yBAAyB;AAC1B;;AAEA;;CAEC,UAAU;CACV,yBAAyB;AAC1B;;AAEA;;EAEE,mBAAmB;EACnB,gDAAgD;EAChD,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,UAAU;EACV,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,UAAU;AACZ;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,gBAAgB;EAChB,0BAA0B;EAC1B,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;AACA;;;EAGE,gCAAgC;EAChC,2BAA2B;AAC7B;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,qCAAqC;AACvC;AACA;;CAEC,iDAAiD;CACjD,yBAAyB;EACxB,mBAAmB;AACrB;;AAEA;;CAEC,UAAU;CACV,yBAAyB;AAC1B;;AAEA;;CAEC,2BAA2B;EAC1B,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,UAAU;EACV,SAAS;EACT,UAAU;EACV,SAAS;AACX;AACA;EAGE,8CAA8C;EAC9C,8CAA8C;AAChD;AACA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,gCAAgC;EAChC,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;;EAEE;AACF;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;IACX,SAAS;IACT,eAAe;AACnB;AACA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,OAAO;EACP,MAAM;EACN,aAAa;AACf;AACA;EACE,wCAAwC;EACxC,eAAe;EACf,YAAY;EACZ,WAAW;EACX,UAAU;EACV,OAAO;EACP,MAAM;EACN,SAAS;EACT,QAAQ;EACR,cAAc;AAChB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;CACC;EACC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;EACb,cAAc;EACd,SAAS;EACT,SAAS;AACX;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,8BAA8B;IAC5B,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,0BAA0B;AAC9B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,2DAA2D;AAC7D;;AAEA;EACE,oCAAoC;EACpC,mDAAmD;AACrD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,SAAS;AACX","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800&family=Nunito:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,200;1,300;1,400;1,500;1,600;1,700;1,800&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');\n\nbody {\n  margin: 0;\n  font-family: 'Poppins', sans-serif;\n  padding: 0;\n  box-sizing: border-box;\nbackground-color: #FAFFF6;\n}\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n/* custom css */\n.slider img {\n  max-width: 100%;\n  margin: auto;\n  outline: none;\n}\n\n.app .slick-dots {\n  bottom: 30px !important;\n  text-align: right !important;\n  right: 30px;\n}\n\n.app .slick-dots li button:before\n{\n    width: 15px !important;\n    height: 15px !important;\n    background-color: #fff;\n    border-radius: 50%;\n    content: '' !important;\n}\n.app .slick-dots li.slick-active button:before\n{\n  width: 25px !important;\n  border-radius: 30px;\n  opacity: 1 !important;\n}\n.app .slick-active\n{\n  margin-right: 10px !important;\n}\n\n.logintext .form-group{\n  position:relative;\n  width: 100%;\n}\n.pr {\n  padding: 0;\n  margin: 0;\n}\n\n.pl {\n  margin: 0;\n  padding: 0;\n}\n.loginpage {\n  position: absolute;\n  width: 100%;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  max-width: 450px;\n}\n\n.logo {\n  max-width: 133px;\n}\n\n.logo img {\n  width: 100%;\n}\n\n.logintext h2 {\n  font-size: 24px;\n  font-weight: 500;\n  line-height: 36px;\n  margin: 0;\n  padding-top: 15px;\n}\n\n.logintext > p {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21px;\n  color: #000000;\n  margin: 0;\n  padding: 15px 0px 40px 0px;\n}\n.error-message {\n  position: absolute;\n  top: 66px;\n  left: 10px;\n  font-size: 14px;\n  color: red;\n}\n.logintext h6 a {color: #0F6739;text-decoration: none;font-size: 14px;font-weight: 500;line-height: 18px;}\n\n.logintext h6 {\n    margin: 0;\n    text-align: right;\n}\n.logintext button {\n  width: 100%;\n  height: 48px;\n  background: #0F6739;\n  border: none;\n  border-radius: 8px;\n  margin-top: 20px;\n  outline: none;\n  padding: 0;\n  color: #fff;\n}\n.logintext button a {\n  color: #fff;\n  display: block;\n  height: 48px;\n  line-height: 48px;\n  width: 100%;\n  text-transform: capitalize;\n  font-size: 14px;\n  text-decoration: none;\n}\n.logintext button:hover\n{\n  background: #0F6739; \n  box-shadow: none;\n}\n\n.customfield .MuiFormControl-root {\n  width: 100%;\n  margin-bottom: 20px;\n}\n.customfield .MuiInputBase-root {\n  background: #fafff6;\n  border: 1px solid #EEEEEE;\n  border-radius: 8px;\n}\n.customfield .MuiInputBase-root:hover {\n  background: #fafff6;\n}\n.customfield .MuiInputBase-root:focus\n{\n  background: #fafff6 !important;\n}\n.customfield .MuiInputBase-root::before\n{\n  border-bottom: 0;\n}\n.customfield .MuiInputBase-root::after\n{\n  border-bottom: 0;\n}\n.MuiFormLabel-root.Mui-focused\n{\ncolor: #0F6739 !important;\n}\n.customfield .MuiInputBase-root:hover::before\n{\n  border-bottom: 0 !important;\n}\n\n.customfield .MuiButtonBase-root {\n  background: transparent !important;\n  height: inherit !important;\n  margin-top: 0 !important;\nwidth: 100%;\n}\n.customfield .MuiButtonBase-root img {\n  filter: invert(15%) sepia(97%) saturate(3007%) hue-rotate(149deg) brightness(88%) contrast(88%);\n}\n\n.customfield .MuiSvgIcon-root {\n  color: #0F6739;\n  top: -5px;\n}\n\n.customfield {\n  display: flex;\n  position: relative;\n}\n\n.pageimage {\n  height: 40px;\n  width: 40px;\n  position: absolute;\n  border: 1px solid #EEEEEE;\n  top: 9px;\n  left: 9px;\n  z-index: 9;\n  border-radius: 8px;\n  line-height: 40px;\n  text-align: center;\n}\nspan.pageimage.pageimagelogin {\n  top: 16px;\n  left: 17px;\n}\n.forgotpass span.pageimage.pageimagelogin {\n  top: 10px;\n  left: 10px;\n}\n.pageimage img {\n  filter: invert(28%) sepia(50%) saturate(731%) hue-rotate(96deg) brightness(95%) contrast(90%);\n  text-align: center;\n  position: relative;\n  top: -3px;\n}\n\n.customfield .MuiInputBase-input {\n  padding-left: 48px;\n}\n.customfield.search .MuiInputBase-input {\n  padding-left: 60px;\n  padding-right: 30px;\n}\n.pageimage-close {\n  position: absolute;\n  right: 10px;\n  top: 15px;\n}\n.pageimage-close:hover{\n  cursor: pointer;\n}\n.customfield.forgotpass .MuiInputBase-input {\n  padding-left: 60px;\n}\n.change-password-page.customfield .MuiInputBase-input{\npadding-left: 60px;\n}\n.customfield #filled-adornment-password {\n  padding-left: 60px;\n}\n.customfield.custom-number .MuiInputBase-input{\npadding-left: 60px;\n}\n.customfield .MuiFormLabel-root {\n  padding-left: 64px;\n  font-family: 'Poppins', sans-serif !important;\n  font-size: 16px;\n  color: #333333;\n}\n\n.customfield.customfieldlogin .MuiFormLabel-root {\n  padding-left: 70px;\n}\n.customfield.customfieldlogin .MuiFormLabel-root.Mui-focused\n{\n  padding-left: 70px !important;\n}\n.customfield.customfieldlogin .MuiInputBase-input {\n  padding-left: 65px;\n}\n.customfield.customfieldlogin button.MuiButtonBase-root {\n  position: relative;\n  right: 10px;\n}\n\n.customfield .MuiInputBase-root.MuiFilledInput-root.MuiFilledInput-underline.MuiInputBase-colorPrimary.MuiInputBase-formControl.MuiInputBase-multiline.Mui-focused\n{\n  background: #fafff6 !important;\n}\n.customfield .MuiInputBase-root.MuiFilledInput-root.MuiFilledInput-underline.MuiInputBase-colorPrimary.MuiInputBase-formControl.MuiInputBase-adornedEnd.Mui-focused\n{\n  background: #fafff6 !important;\n}\n/* menu css */\n\n.mainwrap {\n  width: 100%;\n  height: auto;\n  display: flex;\n}\n\n.leftsection {\n  width: 200px;\n  min-height: 100vh;\n  box-shadow: 0px 4px 8px 0px #DEFFC3;\n  background: #FFFFFF;\n  padding: 22px;\n  position: fixed;\n  left: 0;\n  right: 0;\n  z-index: 10;\n  top: 0;\n  bottom: 0;\n}\n\n.menulogo {\n  width: 110px;\n  margin: 15px auto;\n  padding-bottom: 20px;\n}\n.topallmenu {\n  min-height: calc(100vh - 246px);\n}\n.topallmenuwrap {\n  overflow-y: auto;\n}\n\n.topallmenuwrap ul {\n  max-height: 200px;\n}\n\n.menulogo img {\n  width: 100%;\n}\n\n.menulogo ul {padding: 0;}\n\n.menu ul {\n  padding: 0;\n  margin: 0;\n}\n\n.menu ul li {list-style-type: none;padding: 5px 0px;}\n\n.menu ul li a img {\n  margin: 0px 10px;\n}\n\n.menu ul li a {\n  display: flex;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 21px;\n  text-decoration: none;\n  padding: 12px 10px;\n  color: #666666;\n  align-items: center;\n  border-radius: 8px;\n  border: 1px solid #FAFFF6;\n}\n.menu ul .lasttwomenu li:nth-of-type(1) a {\n  color: #AF4755;\n  border-radius: 0;\n}\n.menu ul .lasttwomenu li:nth-of-type(1)\n{\n  border-bottom: 1px solid #EEEEEE;\n}\n.menu ul .lasttwomenu li:nth-of-type(2) a img\n{\n  background-color: #FAFFF6;\n  height: 40px;\n  width: 40px;\n  padding: 8px;\n  border: 1px solid #EEEEEE;\n  border-radius: 50px;\n}\n.rightsection {\n  padding: 20px;\n  width: calc(100% - 200px);\n  position: absolute;\n  right: 0;\n}\n.topSection {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 20px;\n}\n\n.topSectionleft h3 {\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 36px;\n  color: #333333;\n}\n\n.topSectionleft h3 span {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 21px;\n  color: #666666;\n}\n\n.mainbtn a, .mainbtn button {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 21px;\n  text-align: center;\n  color: #fff !important;\n  background: #0F6739;\n  padding: 14px 20px;\n  border-radius: 8px;\n  text-decoration: none !important;\n  border: none;\n}\n.mainbtn button:focus\n{\n  outline: none;\n}\n.buttonholder button img {\n  position: absolute;\n  max-width: 24px;\n  top: 33px;\n}\n\n.buttonholder {\n  position: relative;\n}\n.no-data-found {\n  display: flex;\n  justify-content: center;\n  padding: 40px 0;\n}\n.mainbtn a:nth-of-type(2), .bulkBTn{\n  background: #77BC43 !important;\n  margin-left: 20px;\n}\n.mainbtn a.csvFile {\n  display: block;\n  padding: 0;\n  background: transparent !important;\n  color: #0F6739;\n  position: relative;\n  top: 20px;\n  margin: 0;\n}\n.mainbtn a.bulkBTn {\n  margin: 0;\n}\n.dashboxwrap {\n  display: flex;\n  justify-content: space-between;\n  padding-bottom: 25px;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.dashbox {\n  background: #fff;\n  box-shadow: 0px 0px 4px 0px #E3F3FF;\n  border-radius: 8px;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  width: calc(25% - 15px);\n  justify-content: space-between;\n}\n\n.dashbox:last-of-type {\n  margin-right: 0px;\n}\n.dashbox-left h3 {\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 36px;\n}\n\n.dashbox-left h4 {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 24px;\n  color: #666666;\n  padding-bottom: 5px;\n}\n\n.dashbox-left p {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 18px;\n  color: #0F6739;\n  margin: 0;\n}\n.dashbox-left h4.assigned\n{\n  color: #0F6739;\n}\n.dashbox-left h4.unassigned\n{\n  color: #AF4755;\n}\n.MuiChartsAxis-right {\n  display: none;\n}\n.MuiChartsAxis-left {\n  display: none;\n}\npath.MuiLineElement-root {\n  display: none;\n}\nrect.MuiBarElement-root {\n  /* width: 10px; */\n  fill: #77BC43;\n}\n\nrect.MuiBarElement-root.MuiBarElement-series-auto-generated-id-1 {\n  fill: #EEEEEE;\n  border-radius: 10px;\n}\ntext.MuiChartsAxis-label {\n  display: none;\n}\n\nline.MuiChartsAxis-tick {\n  display: none;\n}\n\nline.MuiChartsAxis-line {\n  display: none;\n}\ntext.MuiChartsAxis-tickLabel {\n  /* text-anchor: end !important; */\n  font-family: 'Poppins';\n}\n.devicechartwrap {\n  display: flex;\n  justify-content: space-between;\n}\n.devicechart {\n  box-shadow: 0px 0px 4px 0px #E3F3FF;\n  background: #FFFFFF;\n  border-radius: 8px;\n  padding: 20px;\n  width: calc(50% - 10px);\n}\n.devicechart:first-of-type {\n  margin-right: 20px;\n}\n\n.devicechart h2 {\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 36px;\n}\n\n.devicechart p {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 24px;\n  color: #333333;\n}\n.devicechart:nth-of-type(3) {\n  margin-top: 20px;\n}\n.tfirst {\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n\n.tfleft {\n  max-width: 30px;\n}\n.tfleft .pageimage {\n  border-radius: 50%;\n  top: 0;\n}\n\n.tfleft2 {\n  margin-right: 50px;\n}\n\n.tfright2 {\n  padding-left: 10px;\n}\n.tfright p {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 21px;\n  margin: 0;\n}\n.chartcustom svg {\n  margin-top: 0px;\n}\ntable.MuiTable-root {\n  border-top: 1px solid #EEEEEE;\n  margin-top: 20px;\n}\n\n\nth.MuiTableCell-root.MuiTableCell-head.MuiTableCell-sizeMedium{\n  font-family: inherit;\n      white-space: nowrap;\n}\n\ntd.MuiTableCell-root.MuiTableCell-body.MuiTableCell-sizeMedium{\n  font-family: inherit;\n}\ntr.MuiTableRow-root:nth-child( even )\n{\n  background-color: #FAFFF6;\n}\n.MuiPaper-root.MuiPaper-elevation {\n  box-shadow: none;\n}\n.devicechart.tabalwrap {\n  padding: 0;\n  width: 100%;\n}\n\n.tablewrappadd {\n  padding: 20px;\n  padding-bottom: 0;\n}\n.tablewrappadd.filter-energy-d {\n  display: flex;\n  justify-content: space-between;\n}\n.devicechart.tabalwrap p {\n  margin-bottom: 0;\n}\n.devicechart.tabalwrap b {\n  margin-left: 15px;\n  cursor: pointer;\n}\n.tfright span {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  color: #666666;\n  font-family: 'Poppins';\n  white-space: nowrap;\n}\n.tfright p.green\n{\n  color: #0F6739;\n  font-family: 'Poppins';\n  text-transform: capitalize;\n  white-space: nowrap;\n}\n.tfright p.green a {\n  color: #0F6739;\n  font-weight: 500;\n  text-decoration: none;\n  font-family: 'Poppins';\n  text-transform: capitalize;\n}\n.tfright p.status\n{\n  color: #77BC43;\n}\n.adduserwrap {\n  display: flex;\n}\n.userFilter .adduserwrap {\n  display: flex;\n  flex-wrap: wrap;\n}\n.userFilter .selectfield{\n  max-width: 364px;\n}\n.css-6hp17o-MuiList-root-MuiMenu-list{\n  width: 362px !important;\n  overflow-x: auto;\n}\n.mb-20{\n  margin-bottom: 20px;\n}\n.tfright a:hover {\n  text-decoration: none;\n}\n.adduserwrap .customfield {\n  width: 100%;\n  margin-right: 20px;\n  max-width: 364px;\n}\nbody.popup-open:before {\n  background-color: rgb(124 123 123 / 45%);\n  position: fixed;\n  top: 0;\n  left: 0;\n  border: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n  content: \"\";\n  z-index: 100;\n}\n\nbody.popup-open {\n  position: relative;\n}\n.adduserwrap .customfield:last-of-type {\n  margin-right: 0;\n}\n.proof\n{\n  font-family: Poppins;\nfont-size: 16px;\nfont-weight: 500;\nline-height: 24px;\ncolor: #666666;\nmargin-bottom: 20px;\n}\nform.MuiBox-root {\n  width: 100% !important;\n}\n.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input {\n  padding-right: 32px;\n  padding-left: 60px;\n}\nlabel#filled-select-currency-label {\n  padding-left: 65px;\n}\n.MuiInputBase-root.MuiFilledInput-root.MuiFilledInput-underline.MuiInputBase-colorPrimary.Mui-focused.MuiInputBase-formControl {\n  background: #fafff6;\n}\n.selectfield {\n  width: 100%;\n  height: auto;\n  position: relative;\n  max-width: 400px;\n}\n\nimg.arrowb {\n  right: 15px;\n  position: absolute;\n  top: 20px;\n}\n.css-6hp17o-MuiList-root-MuiMenu-list{\n  background-color: #fafff6;\n}\nsvg.MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium.MuiSelect-icon {\n  display: none;\n}\n\nsvg.MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium.MuiSelect-icon.MuiSelect-iconFilled.MuiSelect-iconOpen.css-bpeome-MuiSvgIcon-root-MuiSelect-icon {\n  display: none;\n}\n.css-1ff8729-MuiInputBase-root-MuiFilledInput-root.Mui-focused{\n  background-color:#fafff6 !important;\n}\n.EnergySummary1 td.MuiTableCell-root.MuiTableCell-body.MuiTableCell-sizeMedium, .EnergySummary1 .css-1ex1afd-MuiTableCell-root{\n  white-space:nowrap;\n}\n.bothwrap {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 30px;\n}\n.devicechart.tabalwrap.inputwrap {\n  padding-bottom: 32px;\n}\n\n.devicechart.tabalwrap.inputwrap .mainbtn {\n  padding-top: 35px;\n}\n.mainbtn.bulk {\n  padding-top: 50px !important;\n}.chosefole input {\n  height: 56px;\n  width: 400px;\n}\n.chosefole\n{\n  width: 100%;\n  background: #fafff6;\n  border: 1px solid #EEEEEE;\n  border-radius: 8px;\n  height: 56px;\n}\n.css-zcbmsk-MuiButtonBase-root-MuiButton-root\n{\n  box-shadow: none !important;\n}\n#choose {\n  justify-content: flex-start;\n  padding-left: 55px;\n  text-transform: capitalize;\n  font-size: 16px;\n  color: #333333;\n}\n.chosefole span {\n  font-size: 12px;\n  font-weight: 400;\n  color: #12121259;\n  padding-left: 60px;\n  position: absolute;\n  top: 26px;\n  left: 12px;\n  pointer-events: none;\n}\n.imageuploadmar .chosefole span{\n  top: 10px;\n}\n.userFilter{\n  padding: 0 20px;\n  padding-top: 25px;\n\n}\n.userFilter .selectfield{\nmargin-right: 20px;\n}\n.profilewrap {\n  width: 100%;\n  height: 56px;\n  line-height: 56px;\n  margin-bottom: 12px;\n}\n\n.profilewrap p {\n  padding-left: 58px;\n  line-height: 56px;\n  font-weight: 400;\n  font-size: 14px;\n}\n.bothwrap.tablewrappadd .customfield .MuiFormControl-root {\n  margin-bottom: 0px;\n}\n.customfield.search {\n  max-width: 400px;\n  width: 100%;\n}\n.tfleft.tfleftnew {\n  margin-right: 15px;\n}\n/* .mainbtn button.save\n{\n  padding: 14px 40px;\n} */\n.topSectionright {\n  height: auto;\n  z-index: 0;\n}\n.logintext.Successfully button {\n  margin-top: 0;\n}\na.menu-item.active {\n  background: #0F6739;\n  color: #fff;\n  border-radius: 8px;\n}\n\na.menu-item.active img {\n  filter: invert(100%) sepia(91%) saturate(0%) hue-rotate(308deg) brightness(131%) contrast(101%);\n}\n\n.topallmenuwrap::-webkit-scrollbar-track\n{\n\t-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);\n\tborder-radius: 10px;\n\tbackground-color: #EEEEEE;\n}\n\n.topallmenuwrap::-webkit-scrollbar\n{\n\twidth: 3px;\n\tbackground-color: #EEEEEE;\n}\n\n.topallmenuwrap::-webkit-scrollbar-thumb\n{\n  border-radius: 10px;\n  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);\n  background-color: #77bc4347;\n}\n.devicechart.tabalwrap p.redColor {\n  color: #AF4755;\n}\n\n.devicechart.tabalwrap p.greenColor {\n  color: #77BC43;\n}\n.tfright p button {\n  padding: 0;\n  background: transparent;\n  border: none;\n}\n\n.tfright p button {\n  margin-left: 15px;\n}\n.imageuploadmar\n{\n  margin-bottom: 50px;\n}\n.mainbtn.bulk button img {\n  max-height: 24px;\n}\n.tfleft.tfleftnew span button {\n  border: none;\n  background: transparent;\n  padding: 0;\n}\n\n.tfleft.tfleftnew span button:focus\n{\n  outline: none;\n}\n\n.popup-content {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  background: #fff;\n  padding:20px 0px 15px 20px;\n  box-shadow: 0px 0px 4px 0px #E3F3FF;\n  border-radius: 10px;\n  min-width: 300px;\n  z-index: 101;\n  max-width: 450px;\n}\n.popup-inner-body {\n  overflow-y: auto;\n  max-height: 300px;\n  padding-right: 20px;\n  min-height: 100px;\n}\n.poptext p span {\n  display: block;\n  font-size: 12px;\n  font-weight: 400;\n  color: #666666;\n}\n.poptext a,.poptext a:hover\n{\n  color: #0F6739;\n  text-decoration: none;\n}\n.rs-btn-link:hover{\n  text-decoration: none !important;\n}\n.poptext p {\n  font-size: 14px;\n  font-weight: 500;\n  margin-top: 10px;\n}\n.poptext p:hover{\n  cursor: pointer;\n}\n.popupCloseBtn {\n  margin-top: 10px;\n  float: right;\n  margin-right: 20px;\n  padding: 5px 13px;\n  border-radius: 5px;\n}\n.popupCloseBtn:focus{\n  outline: none;\n  border: none;\n  box-shadow: none;\n}\n.poptext b {\n  color: #0F6739;\n  font-size: 14px;\n  font-weight: 500;\n}\n.rs-input-group-addon > svg{\n  display: none !important;\n}\n.rs-input-group-addon{\n  background-color: #fafff6 !important;\n  position: absolute !important;\n  top: 10px !important;\n}\n.rs-picker-daterange>.rs-input-group.rs-input-group-inside .rs-input{\n  padding-right: 15px !important;\n  /* width: 350px !important; */\n  height: 56px;\n  padding-left: 70px;\n  background-color: #fafff6;\n  font-size: 16px;\n  color: rgba(0, 0, 0, 0.87);\n}\n.rs-picker-daterange>.rs-input-group.rs-input-group-inside .rs-input:focus,.rs-picker-daterange>.rs-input-group.rs-input-group-inside .rs-input:focus-within{\n  box-shadow: none !important;\n}\n.rs-input-group:not(.rs-input-group-disabled):hover,\n.rs-input-group:not(.rs-input-group-disabled).rs-input-group-focus,\n.rs-input-group:focus-within{\n  border-color: #EEEEEE !important;\n  box-shadow: none !important;\n}\n.rs-input-group:not(.rs-input-group-disabled).rs-input-group-focus,\n.rs-input-group:focus-within{\n  outline: none !important;\n}\n.rs-input::-webkit-input-placeholder{\n  color: rgba(0, 0, 0, 0.87) !important;\n}\n.popup-content::-webkit-scrollbar-track\n{\n\t-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);\n\tbackground-color: #F5F5F5;\n  border-radius: 10px;\n}\n\n.popup-content::-webkit-scrollbar\n{\n\twidth: 6px;\n\tbackground-color: #F5F5F5;\n}\n\n.popup-content::-webkit-scrollbar-thumb\n{\n\tbackground-color: #0f673975;\n  border-radius: 10px;\n}\n.tfright button {\n  border: none;\n  background: transparent;\n}\n\n.tfright button:focus\n{\n  outline: none;\n}\n\n.chosefole ::-webkit-file-upload-button {\n  color: transparent;\n  background-color: transparent;\n  outline: 0;\n  border: 0;\n  padding: 0;\n  margin: 0;\n}\n.rs-calendar-table-cell-is-today .rs-calendar-table-cell-content {\n  -webkit-box-shadow: inset 0 0 0 1px #78bc45 !important;\n  -webkit-box-shadow: inset 0 0 0 1px #78bc45 !important;\n  box-shadow: inset 0 0 0 1px #78bc45 !important;\n  box-shadow: inset 0 0 0 1px #78bc45 !important;\n}\n.rs-picker-popup .rs-calendar .rs-calendar-table-cell:hover .rs-calendar-table-cell-content {\n  background-color: #d6fab9 !important;\n  background-color: #d6fab9 !important;\n  color: #116739 !important;\n  color: #116739 !important;\n}\n.rs-calendar-table-cell-selected .rs-calendar-table-cell-content{\n  background-color: #116739 !important;\n  color: #fff !important;\n}\n.rs-calendar-table-cell-in-range::before{\n  background-color: #d6fab9 !important;\n}\n.rs-btn-link{\n  color: #116739 !important;\n}\n.rs-btn-primary{\n  background-color: #116739 !important;\n}\n.rs-btn-link:hover,\n.rs-btn-link:focus{\n  text-decoration: none !important;\n  border: none !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n.rs-btn-close:hover svg path,\n.rs-btn-close:focus svg path{\n  stroke:#116739 !important\n}\n.rs-anim-fade.rs-anim-in{\n  z-index: 10 !important;\n}\n.rs-picker-toggle-wrapper{\n  width: 100% !important;\n}\n.download-excel span {\n  display: block;\n  cursor: pointer;\n  height: 56px;\n}\n\n.download-excel button {\n  background-color: #77BC43;\n  height: 100%;\n  padding: 10px 15px;\n  border-radius: 10px;\n  color: #fff;\n  font-size: 16px;\n}\n.download-excel button:focus {\n  outline: none;\n}\n.filter-data-eng-summary{\n  display: flex;\n    gap: 20px;\n    flex-wrap: wrap;\n}\n.open-menu-mobi {\n  background-color: #e2ebdd75;\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  z-index: 1;\n  left: 0;\n  top: 0;\n  display: none;\n}\n.mob-menu .open-menu-mobi {\n  background-color: rgb(226 235 221 / 30%);\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  z-index: 1;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  display: block;\n}\n.pop-top-heading h6 {\n  color: #666;\n  font-size: 16px;\n  font-weight: 600;\n  padding-bottom: 5px;\n}\n.greenbtn {\n  background-color: #78bc43;\n  color: #fff;\n}\n.red-btn {\n  background-color: #dc3545;\n  color: #fff;\n}\n.poptext {\n  position: relative;\n}\n\n.poptext input {\n  display: none;\n}\n.poptext input:hover{\n  cursor: pointer;\n}\n .radio-btn-check {\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  display: block;\n  border: 2px solid #c4c4c4;\n  border-radius: 4px;\n  top: 16px;\n  right: 0;\n  pointer-events: none;\n}\n.poptext label {\n  width: 100%;\n  margin-bottom: 0;\n}\n.radio-btn-check:before {\n  content: \"\";\n  border: 2px solid #fff;\n  width: 8px;\n  height: 14px;\n  position: absolute;\n  transform: rotate(45deg);\n  border-top: 0;\n  border-left: 0;\n  top: -1px;\n  left: 4px;\n}\n.poptext input:checked ~ .radio-btn-check {\n  border-color: #78bc43;\n  background-color: #78bc43;\n}\n.css-134s3sw-MuiResponsiveChart-container{\n  padding: 30px 0;\n  height: auto !important;\n}\n.user-filter,.user-filter:focus {\n  width: calc(100% - 20px);\n  padding: 8px 8px;\n  border: 1px solid #EEEEEE;\n  background: #fafff6;\n  border-radius:5px;\n  outline: none;\n}\n.no-device-avl {\n  padding: 20px 0;\n}\n.datepick1 .rs-input-group.rs-input-group-inside .rs-input{\n  padding-right: 15px !important;\n    height: 56px;\n    padding-left: 70px;\n    background-color: #fafff6;\n    font-size: 16px;\n    color: rgba(0, 0, 0, 0.87);\n}\n.chart-box-bg .MuiChartsLegend-mark{\n  fill: #77BC43 !important;\n}\n.css-1vh1nrb-MuiChartsTooltip-mark{\n  background-color: #77BC43 !important;\n}\n.chart-box-bg .css-1u0lry5-MuiChartsLegend-root{\n  display: none !important;\n}\n.css-134s3sw-MuiResponsiveChart-container{\n  margin-left: -50px !important;\n  padding-top: 160px;\n}\n.devicechart .css-134s3sw-MuiResponsiveChart-container .css-13aj3tc-MuiChartsSurface-root{\n  height: auto !important;\n}\ninput:-webkit-autofill {\n  background-color: #fafff6 !important;\n  -webkit-box-shadow: 0 0 0px 1000px #fafff6 inset !important;\n}\n\ninput:-webkit-autofill {\n  background-color: #fafff6 !important;\n  box-shadow: 0 0 0px 1000px #fafff6 inset !important;\n}\n.smin-width-360{\n  min-width: 360px;\n}\n.smin-width-360 .customfield .MuiFormControl-root, .battrey-b-0 .customfield .MuiFormControl-root,.dash-user-f .customfield .MuiFormControl-root{\n  margin-bottom: 0px;\n}\n.css-1k2u9zb-MuiChartsAxis-root .MuiChartsAxis-tickLabel{\n  font-size: 11px !important;\n}\n.adduserwrap.gap-20{\n  gap: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
